import { render, staticRenderFns } from "./28_tmc_details_dialog.vue?vue&type=template&id=6caa3870"
import script from "./28_tmc_details_dialog.vue?vue&type=script&lang=js"
export * from "./28_tmc_details_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports